import { DownOutlined } from '@ant-design/icons';
import { Button, Popover, PopoverProps } from 'antd';

import { FilterItemProps } from './FilterItem';
import styles from './FilterPopover.module.css';

type FilterPopoverProps = Pick<FilterItemProps, 'label' | 'name'> & Omit<PopoverProps, 'content'>;

const FilterPopover = ({ label, children, ...props }: FilterPopoverProps) => {
  return (
    <Popover className={styles.popover} placement="bottom" content={children} {...props}>
      {typeof label === 'string' ? (
        <Button>
          {label} <DownOutlined />
        </Button>
      ) : (
        label
      )}
    </Popover>
  );
};

export default FilterPopover;
